import { RecoilRoot } from "recoil";

import React from "react";

export const wrapPageElement = ({ element }) => {
  return <RecoilRoot>{element}</RecoilRoot>;
};
